/**
* map JS
* -----------------------------------------------------------------------------
*
* All the JS for the map component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// VARS that are set in map.php:
// mapLocations - array of objects [{address, city, state, zip, coordinates: {lat, lng}}]
// mapPin - url string of pin image
// mapStyle - url string of mapbox studio style link
// mapKey - string of mapbox api key
( function( app ) {
  const COMPONENT = {

    className: 'map',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // mapKey variable is set in the PHP file
      let paged = 1;
      let isRunning = false;
      mapboxgl.accessToken = ll_mapbox.token;
      $( '.map' ).each( function( key, mapVal ) {
        // Initialize the map
        const mapLocations = $( this ).data( 'locations' );
        const mapId = $( this ).attr( 'id' );
        let map;

        function loadLocations( locations ) {
          const requiredFields = ( loc ) =>
            loc &&
            loc.coordinates &&
            typeof loc.coordinates.lat !== 'undefined' &&
            typeof loc.coordinates.long !== 'undefined' &&
            loc.title &&
            loc.address &&
            loc.address.street &&
            loc.address.city &&
            loc.address.state &&
            loc.address.zip;
          const validLocations = locations.filter( requiredFields );
          const groupedByLatLng = {};

          $( mapVal ).removeClass( 'is-initial' );
          if ( locations.length > 0 ) {
            $( '.map' ).attr( 'data-locations', JSON.stringify( locations ) );
            $( mapVal ).show();
            let zoom = 8;

            if ( locations.length > 1 ) {
              zoom = 11;
            }

            if ( locations.length > 100 ) {
              zoom = 1;
            }
            if ( map ) {
              map.remove(); // Clean up previous instance
            }
            map = new mapboxgl.Map( {
              container: 'map', // mounts on element with id of "map"
              style: ll_mapbox.style, // stylesheet URL set in PHP file
              // this map is centered on the US, but you should change it your location
              center: [-91.44651047786311, 38.69645846992361],
              zoom: zoom,
            } );

            // Wait for the map to load
            map.on( 'load', () => {
              // load the pin image (has to be png or jpg, [SVG DOESN'T WORK])
              // mapPin is set in PHP file
              map.loadImage( ll_mapbox.pin, ( err, img ) => {
                if ( err ) throw err;
                // Will rerference "pin" later
                // if ( $( 'body' ).hasClass( 'page-template-template-providers' ) ) {
                map.addImage( 'll_pin', img );
                // }
                const features = [];
                let i = 0;
                // for multi-location map, iterate over locations and add them to the array of features
                locations.forEach( ( loc, index ) => {
                  const feature = {
                    type: 'Feature',
                    properties: {
                      description:
                        `<p class="text-sm font-medium">${loc.title}</p>
                      <a href="https://www.google.com/maps/place/${loc.address.street}, ${loc.address.city}, ${loc.address.state} ${loc.address.zip}" class="underline text-gray-300 hover:no-underline" target="_blank" title="Find ${loc.title} on Google Maps (Opens in New Tab)">
                        <address class="p-2 not-italic text-sm text-center">
                          <span class="block">${loc.address.street}</span>
                          <span class="block">${loc.address.city}, ${loc.address.state} ${loc.address.zip}</span>
                        </address>
                      </a>`,
                    },
                    geometry: {
                      type: 'Point',
                      coordinates: [parseFloat( loc.coordinates.long ), parseFloat( loc.coordinates.lat )],
                    },
                  };

                  const el = document.createElement( 'div' );
                  el.className = 'marker';
                  el.id = 'marker-' + ( i + 1 );
                  el.innerHTML = '<span><b>' + ( i + 1 ) + '</b></span>';

                  map.setCenter( [parseFloat( loc.coordinates.long ), parseFloat( loc.coordinates.lat )] );

                  // make a marker for each feature and add it to the map
                  new mapboxgl.Marker( el )
                      .setLngLat( feature.geometry.coordinates )
                      .addTo( map );

                  features.push( feature );

                  if ( index === 0 ) {
                    new mapboxgl.Popup( {offset: {'bottom': [0, -49]}} )
                        .setLngLat( feature.geometry.coordinates )
                    // .setHTML( feature.properties.description )
                        .addTo( map );
                  }
                  i++;
                } );

                // add this "geojson" object to the map, passing in the features array
                map.addSource( 'points', {
                  type: 'geojson',
                  data: {
                    type: 'FeatureCollection',
                    features,
                  },
                  cluster: true,
                  clusterMaxZoom: 20, // Max zoom to cluster points on
                  clusterRadius: 50,
                } );

                // create a symbol layer using the "point" source that we just added
                if ( $( 'body' ).hasClass( 'page-template-template-providers' ) ) {
                  map.addLayer( {
                    id: 'points',
                    type: 'symbol',
                    source: 'points',
                    filter: ['!', ['has', 'point_count']],
                    layout: {
                      'icon-image': 'll_pin', // uses the "pin" image we added above
                      'icon-size': 1, // relative to the original image size (unfortunately)
                      'icon-anchor': 'bottom', // will put the bottom center of the pin on the location,
                      'icon-allow-overlap': true,
                    },
                  } );
                } else {
                  map.addLayer( {
                    id: 'points',
                    type: 'symbol',
                    source: 'points',
                    filter: ['!', ['has', 'point_count']],
                    layout: {
                      'icon-image': 'll_pin', // uses the "pin" image we added above
                      'icon-size': 0.5, // relative to the original image size (unfortunately)
                      'icon-anchor': 'bottom', // will put the bottom center of the pin on the location,
                      'icon-allow-overlap': true,
                    },
                  } );
                }

                map.addLayer( {
                  id: 'clusters',
                  type: 'circle',
                  source: 'points',
                  filter: ['has', 'point_count'],
                  paint: {
                    'circle-color': '#51bbd6',
                    'circle-radius': [
                      'step',
                      ['get', 'point_count'],
                      20,
                      10,
                      30,
                      30,
                      40,
                    ],
                    'circle-stroke-width': 1,
                    'circle-stroke-color': '#fff',
                  },
                } );

                // Cluster count labels
                map.addLayer( {
                  id: 'cluster-count',
                  type: 'symbol',
                  source: 'points',
                  filter: ['has', 'point_count'],
                  layout: {
                    'text-field': '{point_count_abbreviated}',
                    'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
                    'text-size': 12,
                  },
                } );

                let clusterPopup = null;
                let clusterPopupIndex = 0;
                let clusterPopupFeatures = [];

                map.on( 'click', 'clusters', function( e ) {
                  const features = map.queryRenderedFeatures( e.point, {
                    layers: ['clusters'],
                  } );
                  const clusterId = features[0].properties.cluster_id;
                  const clusterCoordinates = features[0].geometry.coordinates;

                  // Get the leaves (children) of the cluster
                  map.getSource( 'points' ).getClusterLeaves( clusterId, 100, 0, function( err, leaves ) {
                    if ( err ) return;

                    clusterPopupFeatures = leaves;
                    clusterPopupIndex = 0;

                    // Function to create popup content for a feature
                    function createPopupContent( feature ) {
                      return feature.properties.description +
        '<div style="text-align:center; margin-top:5px;">' +
        '<button id="cluster-popup-prev" style="margin-right:10px;">< Prev</button>' +
        '<button id="cluster-popup-next">Next ></button>' +
        '<p style="margin:5px 0 0 0;">' + ( clusterPopupIndex + 1 ) + ' of ' + clusterPopupFeatures.length + '</p>' +
        '</div>';
                    }

                    // If a popup already exists, remove it
                    if ( clusterPopup ) {
                      clusterPopup.remove();
                    }

                    // Create a new popup at the cluster coordinates
                    clusterPopup = new mapboxgl.Popup( {offset: {'bottom': [0, -49]}} )
                        .setLngLat( clusterCoordinates )
                        .setHTML( createPopupContent( clusterPopupFeatures[clusterPopupIndex] ) )
                        .addTo( map );

                    // Add event listeners for next/prev buttons after popup is added to DOM
                    function addPopupButtonListeners() {
                      const prevBtn = document.getElementById( 'cluster-popup-prev' );
                      const nextBtn = document.getElementById( 'cluster-popup-next' );

                      if ( prevBtn ) {
                        prevBtn.addEventListener( 'click', function( e ) {
                          e.stopPropagation();
                          clusterPopupIndex = ( clusterPopupIndex - 1 + clusterPopupFeatures.length ) % clusterPopupFeatures.length;
                          clusterPopup.setHTML( createPopupContent( clusterPopupFeatures[clusterPopupIndex] ) );
                          addPopupButtonListeners();
                        } );
                      }

                      if ( nextBtn ) {
                        nextBtn.addEventListener( 'click', function( e ) {
                          e.stopPropagation();
                          clusterPopupIndex = ( clusterPopupIndex + 1 ) % clusterPopupFeatures.length;
                          clusterPopup.setHTML( createPopupContent( clusterPopupFeatures[clusterPopupIndex] ) );
                          addPopupButtonListeners();
                        } );
                      }
                    }

                    addPopupButtonListeners();
                  } );
                } );

                // this handles the popups when the pin is clicked
                map.on( 'click', 'points', function( e ) {
                  const coordinates = e.features[0].geometry.coordinates.slice();
                  const description = e.features[0].properties.description;

                  // Ensure that if the map is zoomed out such that multiple
                  // copies of the feature are visible, the popup appears
                  // over the copy being pointed to.
                  while ( Math.abs( e.lngLat.lng - coordinates[0] ) > 180 ) {
                    coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
                  }

                  let popupOffset = 0;
                  if ( $( 'body' ).hasClass( 'page-template-template-providers' ) ) {
                    popupOffset = -49;
                  } else {
                    popupOffset = -10;
                  }

                  new mapboxgl.Popup( {offset: {'bottom': [0, popupOffset]}} )
                      .setLngLat( coordinates )
                      .setHTML( description )
                      .addTo( map );
                } );

                if ( locations.length > 1 ) {
                  const bounds = new mapboxgl.LngLatBounds();

                  features.forEach( function( feature ) {
                    bounds.extend( feature.geometry.coordinates );
                  } );

                  map.fitBounds( bounds, {padding: 100} );
                }

                // make the cursor a pointer when over the pin
                map.on( 'mouseenter', 'points', function() {
                  map.getCanvas().style.cursor = 'pointer';
                } );
                map.on( 'mouseleave', 'points', function() {
                  map.getCanvas().style.cursor = '';
                } );
              } );
            } );
          } else {
            $( mapVal ).hide();
          }
        }

        /*
        * LOCATION SEARCHING
        */

        const locationInput = $( '#location-search input' )[0];
        const distance = 100;
        mapboxgl.accessToken = ll_mapbox.token;

        $( '.fmp-current-location' ).click( function() {
          // $( '#fmp-form' ).find( 'button' ).attr( 'disabled', true );
          if ( navigator.geolocation ) {
            $( '#fmp-form' ).addClass( 'is-disabled' );
            $( '#fmp-form' ).find( 'input[name="fmp-address"]' ).val( '' );
            navigator.geolocation.getCurrentPosition( function( position ) {
              const providerName = $( '#fmp-form' ).find( 'input[name="fmp-name"]' ).val();
              const radius = $( '#fmp-form' ).find( 'select[name="fmp-radius"] option:selected' ).val();
              const treatments = $( '#fmp-form' ).find( 'select[name="fmp-treatments"] option:selected' ).val();
              const brandedTreatments = $( '#fmp-form' ).find( 'select[name="fmp-branded-treatments"] option:selected' ).val();
              const checkedDesignations = $( this ).find( '.designation-input:checked' );
              const designationsArray = [];
              checkedDesignations.each( function() {
                designationsArray.push( $( this ).val() );
              } );
              const designations = designationsArray.join( ',' );
              loadNewLocations( providerName, [position.coords.latitude, position.coords.longitude], radius, treatments, brandedTreatments, designations );
            } );
          } else {
            $( '#fmp-form' ).removeClass( 'is-disabled' );
            alert( 'Unable to retrieve your current location.' );
          }
        } );

        $( document ).on( 'submit', '#fmp-form', function( e ) {
          e.preventDefault();
          if ( !isRunning ) {
            isRunning = true;
            // seth - Hello!
            if ( $( this ).attr( 'data-filtered' ) ) {
              $( this ).removeAttr( 'data-filtered' );
            } else {
              const uncleanParams = $( this ).serializeArray();
              const cleanParams = [];
              const designations = [];
              jQuery.each( uncleanParams, function( i, field ) {
                // console.log( field );
                if ( field.name === 'fmp-designations' ) {
                  designations.push( field.value );
                } else {
                  cleanParams.push( field.name + '=' + field.value + '&' );
                }
              } );
              cleanParams.push( 'fmp-designations=' + designations.join( ',' ) );
              const params = cleanParams.join( '' );
              const nextURL = $( this ).attr( 'data-url' ) + '?' + params;

              // const nextURL = $( this ).attr( 'data-url' ) + '?' + $( this ).serialize();
              const nextTitle = 'Filtered Sciton Providers';
              const nextState = {additionalInformation: 'Filtered the Sciton Providers'};

              // This will create a new entry in the browser's history, without reloading
              window.history.pushState( nextState, nextTitle, nextURL );

              // This will replace the current entry in the browser's history, without reloading
              window.history.replaceState( nextState, nextTitle, nextURL );
            }

            // $( '#fmp-form' ).find( 'button' ).attr( 'disabled', true );
            $( '.navbar .locations-list' ).addClass( 'is-loading' );

            const providerName = $( this ).find( 'input[name="fmp-name"]' ).val();
            const address = $( this ).find( 'input[name="fmp-address"]' ).val();
            const country = $( this ).find( 'select[name="fmp-country"] option:selected' ).val();
            const radius = $( this ).find( 'select[name="fmp-radius"] option:selected' ).val();
            const treatments = $( this ).find( 'select[name="fmp-treatments"] option:selected' ).val();
            const brandedTreatments = $( this ).find( 'select[name="fmp-branded-treatments"] option:selected' ).val();
            const checkedDesignations = $( this ).find( '.designation-input:checked' );
            const designationsArray = [];
            checkedDesignations.each( function() {
              designationsArray.push( $( this ).val() );
            } );
            const designations = designationsArray.join( ',' );

            if ( address ) {
              searchLocations( providerName, address, country, radius, treatments, brandedTreatments, designations );
            } else {
              alert( 'Please provide City, State or Postal Code' );
              isRunning = false;
            }
          }
        } );

        $( '#fmp-form .clear-filters' ).on( 'click', function( e ) {
          e.preventDefault();
          $( '#fmp-form' )[0].reset();
          window.location.href = '/find-my-provider';
        } );

        function searchLocations( providerName = null, searchVal, country, searchDistance, treatments, brandedTreatments, designations ) {
          $.get( 'https://api.mapbox.com/geocoding/v5/mapbox.places/' + searchVal + '.json?country=' + country + '&access_token=' + mapboxgl.accessToken, function( data ) {
            const lat = data.features[0] ? data.features[0].center[1] : null;
            const lng = data.features[0] ? data.features[0].center[0] : null;

            loadNewLocations( providerName, [lat, lng], searchDistance, treatments, brandedTreatments, designations, country, searchVal );
          } );
        }

        function loadNewLocations( providerName = null, coords = [], searchDistance = null, treatments = [], brandedTreatments = [], designations = [], country, searchVal ) {
          $( '#fmp-form' ).addClass( 'is-disabled' );
          const data = {
            name: providerName,
            lat: coords[0],
            long: coords[1],
            distance: searchDistance,
            treatments: treatments,
            brandedTreatments: brandedTreatments,
            designations: designations,
            country: country,
            paged: paged,
            address: searchVal,
          };

          $.ajax( {
            type: 'POST',
            url: site_info.wpApiSettings.ll + 'cpt/filter',
            data: data,
            beforeSend: function( xhr ) {
              xhr.setRequestHeader( 'X-WP-Nonce', site_info.wpApiSettings.nonce );
              xhr.setRequestHeader( 'X-Requested-With', 'XMLHttpRequest' );
              doingAjax = true;
            },
            success: function( data ) {
              isRunning = false;
              $( '.distributor-form' ).removeClass( 'hidden' );
              $( '.providers-area' ).html( data.filtered_providers );
              // console.log( data.debug );
              if ( data.debug.is_paged ) {
                $( '.ll-provider-pagination' ).css( 'display', 'flex' );
                totalPages = data.debug.total_providers / 25;
                let paginationLinks = '';
                paginationLinks += '<button class="paginate-providers" data-paged="prev">Previous</button>';
                paginationLinks += '<p>Page <input type="number" class="ll-paged" value="' + data.debug.current_page + '" maxlength="' + Math.ceil( totalPages ) + '" minlength="1"/> of ' + Math.ceil( totalPages ) + '</p>';
                paginationLinks += '<button class="paginate-providers" data-paged="next">Next</button>';
                $( '.ll-provider-pagination' ).html( paginationLinks );
              }

              $( '.halo.badge-icons' ).on( 'mouseover', function() {
                $( this ).find( '.halo.tooltip' ).addClass( 'show-tooltip' );
              } );

              $( '.halo.badge-icons' ).on( 'mouseleave', function() {
                $( this ).find( '.halo.tooltip' ).removeClass( 'show-tooltip' );
              } );

              $( '.joule.badge-icons' ).on( 'mouseover', function() {
                $( this ).find( '.joule.tooltip' ).addClass( 'show-tooltip' );
              } );

              $( '.joule.badge-icons' ).on( 'mouseleave', function() {
                $( this ).find( '.joule.tooltip' ).removeClass( 'show-tooltip' );
              } );

              if ( data.debug.filtered_providers ) {
                $( '.map-section' ).show();
                const newLocations = [];
                $( '.providers-area .provider' ).each( function( key, val ) {
                  const thisLocation = {};
                  thisLocation.address = {};
                  thisLocation.coordinates = {};
                  thisLocation.address.street = $( val ).find( '.address .street' ).text();
                  thisLocation.address.city = $( val ).find( '.address .city' ).text();
                  thisLocation.address.state = $( val ).find( '.address .state' ).text();
                  thisLocation.address.zip = $( val ).find( '.address .zip' ).text();
                  thisLocation.phone = $( val ).find( '.phone' ).text();
                  thisLocation.formattedPhone = $( val ).find( '.phone' ).text().replace( /[.\D+]/gm, '' );
                  thisLocation.title = $( val ).find( '.title' ).text();
                  thisLocation.coordinates.lat = $( val ).attr( 'data-lat' );
                  thisLocation.coordinates.long = $( val ).attr( 'data-long' );

                  newLocations.push( thisLocation );
                } );
                loadLocations( newLocations, 'providers-map' );
              } else {
                $( '.map-section' ).hide();
              }

              $( '#fmp-form' ).removeClass( 'is-disabled' );
            },
            complete: function( jqXHR, status ) {
              doingAjax = false;
              isRunning = false;
              $( '#fmp-form' ).removeClass( 'is-disabled' );
              $( 'html, body' ).animate( {
                scrollTop: $( '.map-area' ).offset().top,
              }, 800 );
            },
          } );
        }
      } );

      $( document ).on( 'click', '.paginate-providers', function( e ) {
        const _this = $( this );
        if ( _this.data( 'paged' ) === 'prev' ) {
          if ( paged <= 1 ) {
            paged = 1;
          } else {
            paged = parseInt( paged ) - 1;
          }
        }
        if ( _this.data( 'paged' ) === 'next' ) {
          paged = parseInt( paged ) + 1;
        }
        $( '#fmp-form' ).submit();
      } );

      $( document ).on( 'click', '#fmp-form button[type="submit"]', function( e ) {
        e.preventDefault();
        paged = 1;
        $( '#fmp-form' ).submit();
      } );

      $( document ).on( 'change', '.ll-paged', function( e ) {
        const _this = $( this );
        if ( _this.val() <= 1 ) {
          paged = 1;
        } else {
          paged = _this.val();
        }
        $( '#fmp-form' ).submit();
      } );

      $( document ).on( 'change', 'select[name="fmp-country"]', function( e ) {
        const country = $( this ).val().toUpperCase();
        const $radiusSelect = $( 'select[name="fmp-radius"]' );

        // Clear address input
        $( 'input[name="fmp-address"]' ).val( '' );

        // Check if the country is not USA
        if ( country !== 'US' ) {
          // Only add options if they aren't already there
          if ( $radiusSelect.find( 'option[value="200"]' ).length === 0 ) {
            $radiusSelect.append( '<option value="200">200 Miles</option>' );
          }
          if ( $radiusSelect.find( 'option[value="500"]' ).length === 0 ) {
            $radiusSelect.append( '<option value="500">500 Miles</option>' );
          }
        } else {
          // Remove 200 and 500 options if switching back to USA
          $radiusSelect.find( 'option[value="200"], option[value="500"]' ).remove();
        }
      } );

      $( document ).ready( function() {
        const gformConfirmation = $( '.gform_confirmation_wrapper' );
        const country = $( 'select[name="fmp-country"]' ).val().toUpperCase();
        const $radiusSelect = $( 'select[name="fmp-radius"]' );

        if ( gformConfirmation ) {
          // $( 'html, body' ).animate( {
          //   scrollTop: $( '.distributor-form' ).offset().top,
          // }, 800 );
          // $( document ).on( 'gform_confirmation_loaded', function( event, formId ) {
          const confirmationText = $( '#gform_confirmation_message_17' ).html();
          if ( confirmationText && confirmationText.length > 0 ) {
            $( '#gf-popup-message .confirmation-text' ).html( confirmationText );

            $.magnificPopup.open( {
              items: {
                src: '#gf-popup-message',
                type: 'inline',

                mainClass: 'mfp-fade',
                removalDelay: 160,
                preloader: true,
                fixedContentPos: false,
              },
              closeBtnInside: true,
            } );
          }
          // } );
        }

        // Clear address input
        $( 'input[name="fmp-address"]' ).val( '' );

        // Check if the country is not US
        if ( country !== 'US' ) {
          if ( $radiusSelect.find( 'option[value="200"]' ).length === 0 ) {
            $radiusSelect.append( '<option value="200">200 Miles</option>' );
          }
          if ( $radiusSelect.find( 'option[value="500"]' ).length === 0 ) {
            $radiusSelect.append( '<option value="500">500 Miles</option>' );
          }
        } else {
          $radiusSelect.find( 'option[value="200"], option[value="500"]' ).remove();
        }
      } );
      $( document ).on( 'click', '.close-popup', function( e ) {
        e.preventDefault();
        $.magnificPopup.close();
      } );
    },
    finalize: function() {
      if ( window.location.href.indexOf( '?' ) > -1 ) {
        // $( '#fmp-form' ).submit();
      }
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'map', COMPONENT );
} )( app );
